import React from 'react';
import i18n from 'i18n';
import Root from 'pages/Root';
import { Provider } from 'react-redux';
import MomentUtils from '@date-io/moment';
import Store, { persistor } from 'state/store';
import ErrorBoundary from './utils/ErrorBoundary';
import { PersistGate } from 'redux-persist/integration/react';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import gb from 'components/GrowthBookProvider';

i18n();

const App = () => {
  return (
    <ErrorBoundary>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <Provider store={Store}>
          <PersistGate loading={null} persistor={persistor}>
            <GrowthBookProvider growthbook={gb}>
              <Root />
            </GrowthBookProvider>
          </PersistGate>
        </Provider>
      </MuiPickersUtilsProvider>
    </ErrorBoundary>
  );
};

export default App;
